module.exports = __webpack_public_path__ + "img/ps.2ffc2639.png";